import React, { useState } from "react";
import { truncate } from "lodash";
import request from "request"

import Button from "Button";
import Input from "Input"
import Modal from "Modal"

const VenueTabSearchModal = ({
  isOpen,
  setIsOpen,
  selectTab,
}) => {
  const [modalSearchTerm, setModalSearchTerm] = useState("")
  const [venueTabs, setVenueTabs] = useState([])
  const [isLoadingTabs, setIsLoadingTabs] = useState(false)

  const searchTabs = () => {
    setIsLoadingTabs(true)
    setVenueTabs([])
    const req = request.get(`/search/open_tabs?search=${modalSearchTerm}`)
    req.then(({data}) => {
      console.log(data.orders)
      if (data.orders && data.orders.length > 0) {
        setVenueTabs(data.orders)
      }
    })
    req.finally(() => {
      setIsLoadingTabs(false)
    })
  }

  const setVenueTab = (tabId) => {
    setVenueTabs([])
    setModalSearchTerm("")
    setIsOpen(false)
    selectTab(tabId)
  }


  return(
    <Modal
      open={isOpen}
      title="Search Active Venue Tabs"
      actions={
        <div className="is-flex">
        <Button
          text="Close"
          className="is-outlined ml-auto"
          onClick={() => setIsOpen(false)}
        />
        </div>
      }
    >
      <div className="is-flex is-align-items-center">
        <input
          className="input is-flex-grow-1"
          placeholder="Search by Customer Name"
          onChange={(e) => setModalSearchTerm(e.target.value)}
          value={modalSearchTerm}
        />
        <Button
          text="Search"
          className="ml-4"
          onClick={searchTabs}
        />
      </div>
      { isLoadingTabs &&
        <div className="is-flex is-align-items-center is-justify-content-center py-4">
          <p>Searching for tabs....</p>
        </div>
      }
      { !isLoadingTabs && venueTabs.length > 0 &&
        <div className="flex-table mt-4">
          { venueTabs.map((tab, i) => {
            return(
              <div className="flex-table-item" key={i}>
                <div className="flex-table-cell">
                  { tab.customer?.name }
                </div>
                <div className="flex-table-cell">
                  { tab.customer?.phone }
                </div>
                <div className="flex-table-cell">
                  { tab.customer?.name }
                </div>
                <div className="flex-table-cell">
                  <Button
                    text="Activate Tab"
                    onClick={() => setVenueTab(tab)}
                  />
                </div>
              </div>
            )
          })}
        </div>
      }
    </Modal>
  )
}

export default VenueTabSearchModal
